// @flow
import React, { memo } from "react";
import type { MediaItem, Subscription } from "../../data/types";

type Props = {
    className: string,
    currentSubscription: Subscription,
    asset: MediaItem,
    purchaseDetailsMeta: ?Object,
    metadataSchema: Object[],
    changePurchaseDetails: Function,
};

const Meta = (props: Props) => {
	const { metadataSchema, purchaseDetailsMeta } = props;
	const handleChange = (key: string, value: string) => props.changePurchaseDetails({
		metadata: {
			...purchaseDetailsMeta,
			[key]: value,
		},
	});

	return metadataSchema.length
		? <li className={props.className}>
			<table className="metadata-table w-100">
				<tbody>
					{metadataSchema.map((metaDataItem) => (
						<tr key={metaDataItem.key}>
							<td className="pv0 pr6 relative">
								{metaDataItem.name}
								{metaDataItem.required
                            && <span className="dark-red ml2 f2 absolute astrix">*</span>}
							</td>
							<td>
								<input className="bc-menu-icons pv1 ph2 br1 bw1 b--solid w-100 mb-2"
									type="text"
									value={purchaseDetailsMeta && purchaseDetailsMeta[metaDataItem.key]}
									onChange={(e: { target: { value: string } }) => handleChange(metaDataItem.key, e.target.value)}/>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</li> : null;
};

export default memo<Props>(Meta);
